import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { AiOutlineLock } from 'react-icons/ai';
import A1 from '../Images/elo.png'; // Your logo

const ResetPassword = () => {
  const { resetToken } = useParams(); // ✅ Correct token param
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Password validation
    if (!newPassword || !confirmPassword) {
      setError('Enter both password fields.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`https://cloudapi.emedhatechnologies.com/auth/api/reset-password/${resetToken}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password: newPassword }),
      });

      const data = await response.json();
      setLoading(false);

      if (response.ok) {
        setSuccess(data.message || 'Password reset successfully.');
        setError('');
        setNewPassword('');
        setConfirmPassword('');

        setTimeout(() => navigate('/login'), 2000); // Redirect to login
      } else {
        setError(data.error || 'Failed to reset password');
      }
    } catch (err) {
      setLoading(false);
      setError('Failed to reset password. Try again.');
    }
  };

  // ==== STYLES ====
  const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
    backgroundColor: '#f2f2f2',
  };

  const formWrapper = {
    width: '100%',
    maxWidth: '400px',
    padding: '30px',
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    boxSizing: 'border-box',
  };

  const inputWrapper = { position: 'relative', marginBottom: '15px' };
  const iconStyle = { position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)', fontSize: '16px', color: '#666' };
  const inputStyle = { width: '100%', padding: '10px 10px 10px 35px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '12px', boxSizing: 'border-box' };
  const buttonStyle = { width: '100%', padding: '10px', backgroundColor: '#07526f', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' };
  const alertStyle = (type) => ({ padding: '10px', marginBottom: '15px', borderRadius: '4px', color: type === 'error' ? '#842029' : '#0f5132', backgroundColor: type === 'error' ? '#f8d7da' : '#d1e7dd', border: `1px solid ${type === 'error' ? '#f5c2c7' : '#badbcc'}` });

  return (
    <div style={containerStyle}>
      <div style={formWrapper}>
        {/* Logo */}
        <img src={A1} alt="Logo" style={{ height: '40px', display: 'block', margin: '0 auto 20px' }} />
        <h1 style={{ textAlign: 'center', fontSize: '24px', marginBottom: '20px' }}>
          <strong>Reset Password</strong>
        </h1>

        {error && <div style={alertStyle('error')}>{error}</div>}
        {success && <div style={alertStyle('success')}>{success}</div>}

        <form onSubmit={handleResetPassword}>
          {/* New Password */}
          <div style={inputWrapper}>
            <AiOutlineLock style={iconStyle} />
            <input
              type="password"
              placeholder="Enter new password"
              style={inputStyle}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>

          {/* Confirm Password */}
          <div style={inputWrapper}>
            <AiOutlineLock style={iconStyle} />
            <input
              type="password"
              placeholder="Confirm new password"
              style={inputStyle}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          {/* ReCAPTCHA */}
          <div style={{ marginBottom: '15px' }}>
            <ReCAPTCHA sitekey="6LfB4CIqAAAAABTTABOif9nMWUiFuMfIp31_UU5I" />
          </div>

          {/* Submit button */}
          <button type="submit" style={buttonStyle} disabled={loading}>
            {loading ? 'Saving...' : 'Save New Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
